import { bareMimeType, blobToBase64 } from './blobToBase64';

/** The body of `POST /transcribe_voice`. */
export interface TranscribeRequest {
  audio_base64: string;
  mime_type: string;
  field: string;
  hint?: string;
}

/** One recorded clip as the `/transcribe_voice` body; each app posts it with its own client. */
export async function buildTranscribeRequest(
  blob: Blob,
  field: string,
  hint?: string,
): Promise<TranscribeRequest> {
  const body: TranscribeRequest = {
    audio_base64: await blobToBase64(blob),
    mime_type: bareMimeType(blob.type),
    field,
  };
  if (hint) body.hint = hint;
  return body;
}
